const Hero = () => {
  const clients = [
    {
      name: "mercedes",
      logo: "https://talentech.com/wp-content/uploads/2023/05/mercedes-logo-png.png",
    },
    {
      name: "bacardi",
      logo: "https://talentech.com/wp-content/uploads/2023/05/barcardi-logo.png",
    },
    {
      name: "rema",
      logo: "https://talentech.com/wp-content/uploads/2023/07/remalogo.svg-hvid-768x114.png",
    },
    {
      name: "manpower",
      logo: "https://talentech.com/wp-content/uploads/2023/05/mp-logo.png",
    },
    {
      name: "dhl",
      logo: "https://talentech.com/wp-content/uploads/2023/05/dhl-logo-png.png",
    },
  ];
  return (
    <div className="container-fluid bg-primary text-white">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-center h-100 py-5">
              <p className="text-secondary mb-0">
                The complete recruitment & HR platform
              </p>
              <h1 className="display-2 fw-bold mb-4">
                Drive growth with the right, thriving talent
              </h1>
              <ul className="list-unstyled">
                <li className="mb-2 d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-white me-2"></i>Do
                  more with less with our all-in-one recruitment and HR platform
                </li>
                <li className="mb-2 d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-white me-2"></i>
                  Make data driven decisions with secure AI and unique data
                </li>
                <li className="mb-2 d-flex align-items-center">
                  <i className="bi bi-check-circle-fill text-white me-2"></i>Get
                  things done with an intuitive platform your managers will love
                </li>
              </ul>
            </div>
          </div>
          <div className="d-none d-lg-block col-lg-6 mt-4">
            <div className="position-relative h-100 mt-4">
              {/* <img className="position-absolute bottom-0 end-0 hero-image" src={} alt="hero" /> */}
              <img
                className="position-absolute top-50 start-0 translate-middle-y top-rated img-fluid"
                src={
                  "https://talentech.com/wp-content/uploads/2025/05/lorem-ipsum-dolor-sit-amet-consectetur-adipiscing-elit.-122-800x600.webp"
                }
                alt="top-rated"
              />
              {/* <img className="position-absolute top-50 start-50 translate-middle-y value-for-money" src={"valueForMoney"} alt="value-for-money" /> */}
            </div>
          </div>
        </div>
        <div className="row mt-4 py-4">
          <div className="col-12 mt-4">
            <div className="d-flex justify-content-between align-items-center py-5">
              {clients.map((client, index) => (
                <img
                  key={index}
                  src={client.logo}
                  alt={client.name}
                  className="img-fluid"
                  style={{
                    maxHeight: "40px",
                    maxWidth: "100px",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
